import { produce } from 'immer'

const analyticsReducer = produce((draft, action) => {
  switch (action.type) {
    case 'REGISTER_QUERY':
      const existing = draft.queries[action.payload.id]
      if (existing) {
        _.assign(existing, action.payload)
      } else {
        draft.queries[action.payload.id] = {
          queryInfo: null,
          dataLoading: false,
          firstFetch: true,
          data: null,
          chartType: action.payload.defaultChartType,
          ...action.payload
        }
      }
      break

    case 'SET_QUERIES_INFO':
      draft.queriesInfo = action.payload
      draft.queriesInfoLoaded = true
      break

    case 'SET_QUERY_DATA':
      draft.queries[action.payload.id].data = action.payload.data
      draft.queries[action.payload.id].dataLoading = false
      break

    case 'SET_QUERY_DATA_LOADING':
      draft.queries[action.payload.id].dataLoading = action.payload.loading
      break

    case 'UPDATE_QUERY':
      draft.queries[action.payload.id] = { ...draft.queries[action.payload.id], ...action.payload.data }
      break

    case 'UPDATE_DIMENSION':
      const { id: queryId, dimensionId, data } = action.payload
      const dimensionIndex = draft.queries[queryId].dimensions.findIndex(d => d.id === dimensionId)
      draft.queries[queryId].dimensions[dimensionIndex] = { ...draft.queries[queryId].dimensions[dimensionIndex], ...data }
      break

    case 'SET_FILTER':
      const { id, value } = action.payload
      draft.filterValues = { ...draft.filterValues, [id]: value }
      break

    case 'SET_TIME_DIMENSION':
      draft.timeDimension = action.payload.value
      break

    // case 'TOGGLE_SEGMENT_DIMENSION':
    //   const segmentId = action.payload.id
    //   if (draft.activeSegmentDimensions.includes(segmentId)) {
    //     draft.activeSegmentDimensions = draft.activeSegmentDimensions.filter(dim => dim !== segmentId)
    //   } else {
    //     draft.activeSegmentDimensions.push(segmentId)
    //   }
    //   break

    case 'UNREGISTER_QUERY':
      delete draft.queries[action.payload.id]
      break

    case 'UPSERT_LOCAL':
      draft.local = { ...draft.local, ...action.payload }
      break
  }
})

export default analyticsReducer
